"use client"; // src/checkbox.tsx

import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeCheckbox", "name", "checked", "defaultChecked", "required", "disabled", "value", "onCheckedChange", "form"],
    _excluded2 = ["__scopeCheckbox", "forceMount"],
    _excluded3 = ["__scopeCheckbox", "control", "checked", "bubbles", "defaultChecked"];
import * as React from "react";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope } from "@radix-ui/react-context";
import { composeEventHandlers } from "@radix-ui/primitive";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { usePrevious } from "@radix-ui/react-use-previous";
import { useSize } from "@radix-ui/react-use-size";
import { Presence } from "@radix-ui/react-presence";
import { Primitive } from "@radix-ui/react-primitive";
import { jsx, jsxs } from "react/jsx-runtime";
var CHECKBOX_NAME = "Checkbox";

var _createContextScope = createContextScope(CHECKBOX_NAME),
    _createContextScope2 = _slicedToArray(_createContextScope, 2),
    createCheckboxContext = _createContextScope2[0],
    createCheckboxScope = _createContextScope2[1];

var _createCheckboxContex = createCheckboxContext(CHECKBOX_NAME),
    _createCheckboxContex2 = _slicedToArray(_createCheckboxContex, 2),
    CheckboxProvider = _createCheckboxContex2[0],
    useCheckboxContext = _createCheckboxContex2[1];

var Checkbox = React.forwardRef(function (props, forwardedRef) {
  var __scopeCheckbox = props.__scopeCheckbox,
      name = props.name,
      checkedProp = props.checked,
      defaultChecked = props.defaultChecked,
      required = props.required,
      disabled = props.disabled,
      _props$value = props.value,
      value = _props$value === void 0 ? "on" : _props$value,
      onCheckedChange = props.onCheckedChange,
      form = props.form,
      checkboxProps = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      button = _React$useState2[0],
      setButton = _React$useState2[1];

  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setButton(node);
  });
  var hasConsumerStoppedPropagationRef = React.useRef(false);
  var isFormControl = button ? form || !!button.closest("form") : true;

  var _useControllableState = useControllableState({
    prop: checkedProp,
    defaultProp: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : false,
    onChange: onCheckedChange,
    caller: CHECKBOX_NAME
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      checked = _useControllableState2[0],
      setChecked = _useControllableState2[1];

  var initialCheckedStateRef = React.useRef(checked);
  React.useEffect(function () {
    var form2 = button === null || button === void 0 ? void 0 : button.form;

    if (form2) {
      var reset = function reset() {
        return setChecked(initialCheckedStateRef.current);
      };

      form2.addEventListener("reset", reset);
      return function () {
        return form2.removeEventListener("reset", reset);
      };
    }
  }, [button, setChecked]);
  return /* @__PURE__ */jsxs(CheckboxProvider, {
    scope: __scopeCheckbox,
    state: checked,
    disabled: disabled,
    children: [/* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({
      type: "button",
      role: "checkbox",
      "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
      "aria-required": required,
      "data-state": getState(checked),
      "data-disabled": disabled ? "" : void 0,
      disabled: disabled,
      value: value
    }, checkboxProps), {}, {
      ref: composedRefs,
      onKeyDown: composeEventHandlers(props.onKeyDown, function (event) {
        if (event.key === "Enter") event.preventDefault();
      }),
      onClick: composeEventHandlers(props.onClick, function (event) {
        setChecked(function (prevChecked) {
          return isIndeterminate(prevChecked) ? true : !prevChecked;
        });

        if (isFormControl) {
          hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
          if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
        }
      })
    })), isFormControl && /* @__PURE__ */jsx(CheckboxBubbleInput, {
      control: button,
      bubbles: !hasConsumerStoppedPropagationRef.current,
      name: name,
      value: value,
      checked: checked,
      required: required,
      disabled: disabled,
      form: form,
      style: {
        transform: "translateX(-100%)"
      },
      defaultChecked: isIndeterminate(defaultChecked) ? false : defaultChecked
    })]
  });
});
Checkbox.displayName = CHECKBOX_NAME;
var INDICATOR_NAME = "CheckboxIndicator";
var CheckboxIndicator = React.forwardRef(function (props, forwardedRef) {
  var __scopeCheckbox = props.__scopeCheckbox,
      forceMount = props.forceMount,
      indicatorProps = _objectWithoutProperties(props, _excluded2);

  var context = useCheckboxContext(INDICATOR_NAME, __scopeCheckbox);
  return /* @__PURE__ */jsx(Presence, {
    present: forceMount || isIndeterminate(context.state) || context.state === true,
    children: /* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({
      "data-state": getState(context.state),
      "data-disabled": context.disabled ? "" : void 0
    }, indicatorProps), {}, {
      ref: forwardedRef,
      style: _objectSpread({
        pointerEvents: "none"
      }, props.style)
    }))
  });
});
CheckboxIndicator.displayName = INDICATOR_NAME;
var BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var CheckboxBubbleInput = React.forwardRef(function (_ref, forwardedRef) {
  var __scopeCheckbox = _ref.__scopeCheckbox,
      control = _ref.control,
      checked = _ref.checked,
      _ref$bubbles = _ref.bubbles,
      bubbles = _ref$bubbles === void 0 ? true : _ref$bubbles,
      defaultChecked = _ref.defaultChecked,
      props = _objectWithoutProperties(_ref, _excluded3);

  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(ref, forwardedRef);
  var prevChecked = usePrevious(checked);
  var controlSize = useSize(control);
  React.useEffect(function () {
    var input = ref.current;
    if (!input) return;
    var inputProto = window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    var setChecked = descriptor.set;

    if (prevChecked !== checked && setChecked) {
      var event = new Event("click", {
        bubbles: bubbles
      });
      input.indeterminate = isIndeterminate(checked);
      setChecked.call(input, isIndeterminate(checked) ? false : checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  var defaultCheckedRef = React.useRef(isIndeterminate(checked) ? false : checked);
  return /* @__PURE__ */jsx(Primitive.input, _objectSpread(_objectSpread({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : defaultCheckedRef.current
  }, props), {}, {
    tabIndex: -1,
    ref: composedRefs,
    style: _objectSpread(_objectSpread(_objectSpread({}, props.style), controlSize), {}, {
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    })
  }));
});
CheckboxBubbleInput.displayName = BUBBLE_INPUT_NAME;

function isIndeterminate(checked) {
  return checked === "indeterminate";
}

function getState(checked) {
  return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}

var Root = Checkbox;
var Indicator = CheckboxIndicator;
export { Checkbox, CheckboxIndicator, Indicator, Root, createCheckboxScope };